import { Link } from 'react-router-dom';

const areas = [
  {
    name: 'Downtown Nashville',
    icon: 'ri-building-line',
    description: 'Restaurants, hospitality, retail, and professional services in the heart of Nashville.',
  },
  {
    name: 'East Nashville',
    icon: 'ri-store-2-line',
    description: 'Boutiques, salons, cafes, and creative businesses across 5 Points and Inglewood.',
  },
  {
    name: 'Franklin & Brentwood',
    icon: 'ri-home-office-line',
    description: 'Professional services, home services, and established businesses in Williamson County.',
  },
  {
    name: 'Murfreesboro & Beyond',
    icon: 'ri-map-pin-line',
    description: 'Serving all of Middle Tennessee — from Hendersonville to Spring Hill and everywhere between.',
  },
];

export default function NashvilleSection() {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="nashville" className="py-20 lg:py-32 bg-gradient-to-b from-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-12 lg:mb-20">
          <div>
            <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
              <span className="text-sm text-gray-300 font-medium">Nashville, TN Web Development</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Web Development for Nashville Small Businesses
            </h2>
            <p className="text-base sm:text-lg text-gray-400 leading-relaxed mb-6">
              Nashville is one of the fastest-growing cities in the country — and local businesses need a strong online presence to keep up. GWDevelopers provides <strong className="text-white">AI-powered website design in Nashville</strong> that helps small businesses compete online without the big agency price tag.
            </p>
            <p className="text-base sm:text-lg text-gray-400 leading-relaxed mb-8">
              Whether you're a contractor in Brentwood, a restaurant in East Nashville, a salon in Franklin, or a professional service firm Downtown — we build websites that rank locally and convert visitors into paying customers.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <button
                onClick={scrollToContact}
                className="px-8 py-4 bg-white text-black font-semibold rounded-lg hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Get a Free Demo Website
              </button>
              <Link
                to="/portfolio"
                className="px-8 py-4 border border-white/30 text-white font-semibold rounded-lg hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                View Nashville Examples
              </Link>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden border border-white/10 mt-4 lg:mt-0">
            <img
              src="https://static.readdy.ai/image/8054a7de0b572fc3037c5f8704bad458/a8b2fa9e08c12fee75679ccae676aa7a.webp"
              alt="Nashville Tennessee skyline — GWDevelopers serves small businesses across Nashville, Franklin, Brentwood, and East Nashville"
              title="Web development for Nashville, TN small businesses"
              className="w-full h-60 sm:h-80 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <p className="text-white font-bold text-xl">Nashville, TN</p>
              <p className="text-gray-300 text-sm">Serving all of Middle Tennessee</p>
            </div>
          </div>
        </div>

        {/* Service areas grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {areas.map((area, index) => (
            <div
              key={index}
              className="bg-black border border-white/10 rounded-2xl p-6 sm:p-8 hover:border-white/25 transition-all duration-300"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-white/20 rounded-full mb-4 sm:mb-5">
                <i className={`${area.icon} text-lg sm:text-xl text-white`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2 sm:mb-3">{area.name}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{area.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Not sure if we serve your area?{' '}
            <button
              onClick={scrollToContact}
              className="text-white hover:underline cursor-pointer"
            >
              Reach out — we serve all of Middle Tennessee
            </button>
          </p>
        </div>
      </div>
    </section>
  );
}
